import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { forkJoin, Observable, Subscription } from 'rxjs';
// models
import { UnidadesModel } from '../../models/unidades.model';
// services
import { RoutesService } from '../../../../../../services/routes.service';
import { UnitsService } from '../../../../../../services/units.service';
import { BroadcastService } from '../../../../../../shared/services/broadcast.service';
import { FormService } from '../../../../../../shared/services/form.service';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'unidades-edit-create',
    templateUrl: './edit-create.component.html',
    styleUrls: ['./edit-create.component.scss']
})
export class UnidadesEditCreateComponent implements OnInit, OnDestroy {
    @Input() data: any = {};
    formGroup: RxFormGroup;
    subscriptions: Array<Subscription | Observable<any>> = [];

    routesList = [];

    constructor(
        public modalRef: BsModalRef,
        private broadcast: BroadcastService,
        private formService: FormService,
        private routesService: RoutesService,
        private unitsService: UnitsService
    ) {
        this.subscriptions.push(
            this.formService._formEvents.subscribe(data => {
                this.formGroup = data;
            })
        );
    }

    ngOnInit(): void {
        this.formService.transformIntoFormGroup(UnidadesModel, Object.assign(this.data, { active: true }));

        if ('id' in this.data) {
            this.subscriptions.push(
                forkJoin([
                    this.routesService.list(),
                    this.unitsService.show(this.data.id),
                ]).subscribe(data => {
                    this.routesList = data[0]['response'];
                    this.formGroup.patchModelValue(data);
                })
            );
        }

    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
    }

    /**
   * 
   */
    submit(): void {
        this.subscriptions.push(
            this.unitsService.createOrUpdate(this.formGroup, this.data?.id).subscribe(
                data => {
                    this.broadcast.reloadDataTable();
                    this.modalRef.hide();
                }
            )
        );
    }

}
